<div>{{ campaignStep()?.name || 'New Step' }}</div>
